import React, { useCallback, useContext, useEffect } from "react";
import {
  Button,
  navigateToAuthorizeEndpoint,
  router,
  translate
} from "clavis-nxt-components-custdevtm";
import { ModuleConfigContext } from "../ModuleConfigContext/ModuleConfigContext";
import "./LoginStyle.scss";
import moment from "moment";

/** Get gatekeeper config from context.
 *  @param {?Object} context - Context object.
 *  @return {?Object} */
const resolveGatekeeperConfig = context =>
  context &&
  Object.hasOwn(context, "modules") &&
  Object.hasOwn(context.modules, "gatekeeper")
    ? context.modules.gatekeeper
    : null;

const Logout = props => {
  const moduleConfigContext = useContext(ModuleConfigContext);
  const { t } = props;

  useEffect(() => {
    if (props.routerHistory && props.routerHistory.forceReload) {
      window.clavisNxtHistory.replace("/logout");
      window.location.reload();
    }
  }, []);

  /** Memoized navigate to authorized endpoint function. */
  const memoizedOnClickLogout = useCallback(
    () =>
      navigateToAuthorizeEndpoint(resolveGatekeeperConfig(moduleConfigContext)),
    [moduleConfigContext]
  );

  if (props.routerHistory && props.routerHistory.forceReload) {
    return <div />;
  } else {
    return (
      <div className="login-page page-header-background-color">
        <div className="header-logo application-header-logo-66" />
        <div className="title huge-font-medium page-header-color">
          {t("platform.Logout.logout")}
        </div>
        <div className="logout-box interaction-background-color">
          <Button onClick={memoizedOnClickLogout}>
            {t("platform.Logout.backToApplication")}
          </Button>
        </div>
        <div className="footer-logo " />
        <div className="subtitle page-header-color small-font-regular ">
          {t("cdt.Login.subtitle")}
        </div>
        <div>
          <div className="copyright page-header-color small-font-regular ">
            © Copyright {moment().format("YYYY")} HUNFedezetkezelő Zrt.
          </div>
        </div>
      </div>
    );
  }
};

export default router(translate()(Logout));
